import { WidgetSizeT } from "../../../localTypes/WidgetSizeT";

export const taskSingleWidgetSizes: WidgetSizeT[] = [
  { w: 1, h: 1 },
  { w: 2, h: 1 },
];
